import axiosInstance from "./axiosInstance";

const API_URL = process.env.REACT_APP_API_URL;

// GET all billOfLabourWos
export const getBillOfLabourWos = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-labour-wo`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching bill-of-labour-wo:",
      error.response?.data || error,
    );
    throw error;
  }
};

// GET a single billOfLabourWo
export const getBillOfLabourWoById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/bill-of-labour-wo/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching bill-of-labour-wo:",
      error.response?.data || error,
    );
    throw error;
  }
};

// CREATE a new billOfLabourWo
export const createBillOfLabourWo = async (billOfLabourWoData) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/bill-of-labour-wo`,
      billOfLabourWoData,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error creating bill-of-labour-wo:",
      error.response?.data || error,
    );
    throw error;
  }
};

// UPDATE an existing billOfLabourWo
export const updateBillOfLabourWo = async (id, billOfLabourWoData) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/bill-of-labour-wo/${id}`,
      billOfLabourWoData,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error updating bill-of-labour-wo:",
      error.response?.data || error,
    );
    throw error;
  }
};

// DELETE a billOfLabourWo
export const deleteBillOfLabourWo = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${API_URL}/bill-of-labour-wo/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error deleting bill-of-labour-wo:",
      error.response?.data || error,
    );
    throw error;
  }
};

// GET billOfLabourWos by workOrderId
export const getBillOfLabourWosByWorkOrderId = async (workOrderId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-labour-wo`, {
      params: { workOrderId },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching bill-of-labour-wo by WO:",
      error.response?.data || error,
    );
    throw error;
  }
};

// GET billOfLabourWos by many workOrderIds
export const getBillOfLabourWosByWorkOrderIds = async (workOrderIds = []) => {
  if (!workOrderIds.length) {
    return [];
  }

  try {
    const response = await axiosInstance.get(
      `${API_URL}/bill-of-labour-wo/by-work-order-ids`,
      {
        params: { workOrderIds: workOrderIds.join(",") },
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching bill-of-labour-wo by WO IDs:",
      error.response?.data || error,
    );
    throw error;
  }
};
